import { Box, ListItem, Text, UnorderedList } from "@chakra-ui/react";

export const getPublicationIssues = (script: any): string[] => {
  const issues: string[] = [];
  if (!script?.name?.trim()) issues.push("Script name is missing.");
  if (!script?.document?.trim()) issues.push("Score document is missing.");
  if (!script?.image?.trim()) issues.push("Score image/preview is missing.");
  if (!script?.composerId) issues.push("Composer linkage is missing.");
  if (!script?.categories?.some((category) => category?.id))
    issues.push("Catalogue category linkage is missing.");
  if (script?.categories?.some((category) => category?.slug === "other-not-listed"))
    issues.push("Replace Other / Not Listed with a publication category in Edit.");
  if (Array.isArray(script?.languages) && !script.languages.some((language) => language?.id))
    issues.push("Catalogue language linkage is missing.");
  if (!script?.description?.trim()) issues.push("Description is missing.");
  const lyrics = script?.meta?.lyrics;
  // Rich text containing only empty paragraphs is not useful publication content.
  if (
    typeof lyrics !== "string" ||
    !lyrics
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;|&#160;/gi, " ")
      .trim()
  )
    issues.push("Lyrics are missing.");
  return issues;
};

const PublicationReadiness = ({
  script,
  categoryNeedsReview,
  languageNeedsReview,
}: {
  script: any;
  categoryNeedsReview?: boolean;
  languageNeedsReview?: boolean;
}) => {
  const issues = getPublicationIssues(script);
  return (
    <Box
      borderWidth="1px"
      borderRadius="md"
      p={4}
      my={4}
      bg={issues.length ? "orange.50" : "green.50"}
    >
      <Text fontWeight="bold">Publication readiness</Text>
      {issues.length > 0 ? (
        <>
          <Text mt={2}>
            Contributor submission is valid with incomplete publication metadata. Fix the following
            before publication, then approve.
          </Text>
          <UnorderedList mt={2}>
            {issues.map((issue) => (
              <ListItem key={issue}>{issue}</ListItem>
            ))}
          </UnorderedList>
        </>
      ) : (
        <Text mt={2}>
          The listed publication fields are present. The server will validate approval.
        </Text>
      )}
      {(categoryNeedsReview ?? script.categoryNeedsReview) && (
        <Text mt={2}>Category needs review: confirm a catalogue match before publication.</Text>
      )}
      {(languageNeedsReview ?? script.languageNeedsReview) && (
        <Text mt={2}>Language needs review: confirm a catalogue match before publication.</Text>
      )}
      {issues.length > 0 && (
        <Text mt={2}>Edit the script to add missing content or correct its catalogue links.</Text>
      )}
    </Box>
  );
};
export default PublicationReadiness;
